import styled from 'styled-components';
import { Link } from 'react-router-dom';  

// Styled component definition
const BodyLink = styled(Link)`
  background-color: ${(props) => props.activeColor || 'white'};
  border-radius: 10px;
  padding: 10px 20px;
  margin: 5px;
  color: ${(props) =>
    props.activeColor ? 'white' : 'rgba(138, 94, 191, 1)'};
  border: ${(props) =>
    props.activeColor ? '' : 'dashed 2px rgba(138, 94, 191, 1)'};
  text-decoration: none;

  &:hover {
    color: ${(props) =>
      props.activeColor ? 'white' : 'rgba(138, 94, 191, 1)'};
  }
`;

export default BodyLink;